import { WidgetWithConfigState } from 'widgets/store/configuration/WidgetWithConfigState';
import {
    initialTilesConfigState,
    CapsuleContainerWidgetConfigState,
} from 'widgets/tiles/store/config/CapsuleContainerWidgetConfigState';

export type CapsuleContainerWidgetState =
    WidgetWithConfigState<CapsuleContainerWidgetConfigState>;

export interface CapsuleContainersWidgetsState {
    [widgetKey: string]: CapsuleContainerWidgetState;
}

export const initialTilesWidgetState: CapsuleContainerWidgetState = {
    config: initialTilesConfigState,
};

export const initialTilesWidgetsState: CapsuleContainersWidgetsState = {};
